function Ecommerce() {}

Ecommerce.prototype.push = function(eventName, products) {
    if (!window.dataLayer) {
        return;
    }

    if (!eventName) {
        return console.error('eventName is empty');
    }

    if (!Array.isArray(products) || products.length === 0) {
        return console.error('products is empty');
    }

    const pushObject = {
        "ecommerce": {
            "currencyCode": "RUB",
        }
    }

    pushObject[eventName] = {
        products: products,
    }

    console.log(pushObject);
    window.dataLayer.push(pushObject);
}

Ecommerce.prototype.purchase = function(actionFieldId, products) {
    if (!window.dataLayer) {
        return;
    }

    if (!actionFieldId) {
        return console.error('actionFieldId is empty');
    }

    if (!Array.isArray(products) || products.length === 0) {
        return console.error('products is empty');
    }

    const pushObject = {
        ecommerce: {
            currencyCode: "RUB",
            purchase: {
                actionField: {
                    id: actionFieldId,
                },
                products: products
            }
        }
    }

    console.log(pushObject);
    window.dataLayer.push(pushObject);
}

export default new Ecommerce();